import React from "react";

import "../styles/RightRail.css";
import { BoardInput } from "./BoardInput";
import { ComboChart } from "./Chart";
import { AddCombosButtons } from "./AddCombosButtons";
import { EquityDisplay, DisplayRanges } from "./RightSideBar";

function Section(props) {
  const { label, grow, children } = props;
  return (
    <div className={grow ? "railSection railSection--grow" : "railSection"}>
      <span className="railLabel">{label}</span>
      {children}
    </div>
  );
}

// The working column: everything you touch between picking a hand and
// reading its equity, in the order you use it.
export default function RightRail(props) {
  return (
    <div className="rightRail">
      <Section label="Board">
        <BoardInput />
      </Section>
      <Section label="Hand">
        <div className="railHand">
          <ComboChart />
          <AddCombosButtons />
        </div>
      </Section>
      <Section label="Selected combos">
        <DisplayRanges dark />
      </Section>
      <Section label="Equity" grow>
        <EquityDisplay />
      </Section>
    </div>
  );
}
